import React from "react";
import { Link } from "react-router-dom";
import "./css/LoginPage.css";
import API_BASE from "./config";

const LoginPage = () => {
    const handleSignIn = () => {
        window.location.href = "https://us-east-15omn7uhsf.auth.us-east-1.amazoncognito.com/login?client_id=31lq7qsuf5epcgbh7kocl350sa&redirect_uri=https://cloudgenomics.net/auth/callback&response_type=code";
    };

    const containerStyle = {
    padding: "60px 40px",
    maxWidth: "520px",
    margin: "80px auto",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
    borderRadius: "18px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
    textAlign: "center"
  };

  const primaryButtonStyle = {
    padding: "14px",
    fontSize: "16px",
    background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
    color: "#ffffff",
    border: "none",
    borderRadius: "12px",
    cursor: "pointer",
    width: "260px",
    marginBottom: "18px",
    boxShadow: "0 8px 20px rgba(37,99,235,0.35)"
  };

  const secondaryButtonStyle = {
    display: "inline-block",
    padding: "14px",
    fontSize: "16px",
    background: "linear-gradient(135deg, #16a34a, #15803d)",
    color: "#ffffff",
    borderRadius: "12px",
    textDecoration: "none",
    width: "260px",
    boxShadow: "0 8px 20px rgba(22,163,74,0.35)"
  };

  return (
    <div style={containerStyle}>
      <img
        src="/cloudgenomics_black_medium.png"
        alt="CloudGenomics"
        style={{ width: "260px", marginBottom: "30px" }}
      />

      <h2 style={{ color: "#0f172a", marginBottom: "8px" }}>
        Welcome to CloudGenomics
      </h2>
      <p style={{ color: "#64748b", marginBottom: "36px" }}>
        Secure genomic analysis and insights platform
      </p>

      <button onClick={handleSignIn} style={primaryButtonStyle}>
        Sign In
      </button>

      <br />

      <Link to="/request-access" style={secondaryButtonStyle}>
        Request Access
      </Link>

      <br/><br/>
      <br />

      <Link to="/about" style={{ 
          display: "inline-block",
          marginTop: "16px",
          color: "#2563eb",
          textDecoration: "none",
          fontSize: "15px"
      }}>
        About CloudGenomics
      </Link>

    </div>
  );
};

export default LoginPage;